import { Button, Divider, Input, Modal, Spin } from "antd";
import { useState } from "react";
import "../SearchAndStatus/SearchAndStatus.scss";
import { useHistory } from "react-router-dom";

var axios = require("axios");
const SearchAndStatus = () => {
  var history = useHistory();
  const [searchFormValues, setSearchFormValues] = useState({
    mobile: "",
    id: "",
  });
  const [searchFormValuesQR, setSearchFormValuesQR] = useState({
    qr_code: "",
  });
  const [mobileGovIDError, setmobileGovIDError] = useState(false);
  const [QRCodeError, setQRCodeError] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [apiError, setAPIError] = useState("");
  const [couponStatus, setCouponStatus] = useState("");
  const [spinner, setSpinner] = useState(false);

  const [couponsInfo, setCouponsInfo] = useState({
    status: "",
    redeemed_on: "",
    redeemed_by: {
      firstname: "",
      lastname: "",
      mobile: "",
      email: "",
    },
    issued_on: "",
    valid_till: "",
  });

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleChange =
    (name: string) => (event: { target: { value: any } }) => {
      setSearchFormValues({ ...searchFormValues, [name]: event.target.value });
      if (name === "mobile") {
        setSearchFormValues({
          ...searchFormValues,
          mobile: event.target.value,
          id: "",
        });
      } else if (name === "id") {
        setSearchFormValues({
          ...searchFormValues,
          id: event.target.value,
          mobile: "",
        });
      }
      setmobileGovIDError(false);
    };

  const onChangeQRCode =
    (name: string) => (event: { target: { value: any } }) => {
      setSearchFormValuesQR({
        ...searchFormValuesQR,
        [name]: event.target.value,
      });
      setQRCodeError(false);
      setCouponStatus("");
    };

  const onSubmit = () => {
    const data = JSON.stringify(searchFormValues);
    const url =
      searchFormValues.id !== ""
        ? `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}` +
          "customer/get?external_id=" +
          searchFormValues.id +
          "&format=json"
        : searchFormValues.mobile !== ""
        ? `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}` +
          "customer/get?mobile=" +
          searchFormValues.mobile +
          "&format=json"
        : null;
    if (searchFormValues.id !== "" || searchFormValues.mobile !== "") {
      setSpinner(true);
      const token = localStorage.getItem("BASIC_TOKEN");
      var config = {
        method: "get",
        url: url,
        headers: {
          Authorization: "Basic " + token,
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(config)
        .then((response: any) => {
          if (
            response.data &&
            response.data.response &&
            response.data.response.status &&
            response.data.response.status.code === 200
          ) {
            const customerName =
              response.data.response.customers.customer[0].firstname;
            localStorage.setItem("customerName", customerName);
            console.log(response);
            if (localStorage.getItem("customerName") !== "undefined") {
              const data: any = {
                id: searchFormValues.id,
                mobile: searchFormValues.mobile,
              };
              setSpinner(false);
              history.push({ pathname: "/customer/profile", state: data });
            } else {
            }
          } else {
            setAPIError("No users found");
            showModal();
            setSpinner(false);
          }
        })
        .catch((error: any) => {
          console.log(error);
          setAPIError("Something went wrong. Please try again");
          showModal();
          setSpinner(false);
        });
    } else {
      setmobileGovIDError(true);
    }
  };

  const handleKeypress = (event: any) => {
    if (event.key === "Enter") {
      onSubmit();
    }
  };

  const handleEnterPress = (event: any) => {
    if (event.key === "Enter") {
      searchUserByQRCode();
    }
  };

  const searchUserByQRCode = () => {
    if (searchFormValuesQR.qr_code !== "") {
      setSpinner(true);
      const token = localStorage.getItem("BASIC_TOKEN");
      var config = {
        method: "get",
        url:
        `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}` +
          "coupon/get?code=" +
          searchFormValuesQR.qr_code +
          "&format=json",
        headers: {
          Authorization: "Basic " + token,
          "Content-Type": "application/json",
        },
      };
      axios(config)
        .then((response: any) => {
          setSpinner(false);
          console.log(response);
          setCouponStatus(response.data.response.status.success);
          if (response.data.response.status.code === 200) {
            var couponsDetails = response.data.response.coupons.coupon[0];
            if (couponsDetails.redemption_info?.redeemed === "true") {
              setCouponsInfo({
                ...couponsInfo,
                status: "Redeemed",
                redeemed_on: couponsDetails.redemption_info.redeemed_on,
                redeemed_by: couponsDetails.redemption_info.redeemed_by,
              });
            } else {
              setCouponsInfo({
                ...couponsInfo,
                status: "Available",
                issued_on: couponsDetails.issued_on,
                valid_till: couponsDetails.valid_till,
                redeemed_on: "",
                redeemed_by: {
                  firstname: "",
                  lastname: "",
                  mobile: "",
                  email: "",
                },
              });
            }
          } else {
            setCouponsInfo({
              ...couponsInfo,
              status: "Invalid",
              redeemed_on: "",
              redeemed_by: {
                firstname: "",
                lastname: "",
                mobile: "",
                email: "",
              },
              issued_on: "",
            });
          }
        })
        .catch((error: any) => {
          console.log(error);
          setSpinner(false);
        });
    } else {
      setQRCodeError(true);
    }
  };

  return (
    <>
      <div style={{ paddingBottom: 20 }}>
        <div className="SearchAndStatusContainer">
          <p className="title">Dashboard</p>
          <div className="SearchContainer">
            <div className="SearchUserDetails">
              <p className="formTitle">Search by User Details</p>

              <div className="formInput">
                <Divider></Divider>
                <label>Mobile Number</label>
                <Input
                  value={searchFormValues.mobile}
                  onChange={handleChange("mobile")}
                  placeholder="Enter Mobile Number"
                  onKeyPress={handleKeypress}
                />
              </div>

              <div className="formInput">
                <Divider>OR</Divider>
                <label>Government ID</label>
                <Input
                  value={searchFormValues.id}
                  onChange={handleChange("id")}
                  placeholder="Enter Government ID"
                  onKeyPress={handleKeypress}
                />
              </div>
              {mobileGovIDError ? (
                <div>
                  <p className="errorText">
                    Please Enter Mobile Number OR Government ID
                  </p>
                </div>
              ) : null}

              <div>
                <Button
                  type="primary"
                  style={{ maxWidth: "75%" }}
                  onClick={onSubmit}
                >
                  Search
                </Button>
              </div>
            </div>
            <div className="SearchByQR">
              <p className="formTitle">Search by QR Code</p>
              <div className="formInput">
                <Divider></Divider>
                <label>QR Code</label>
                <Input
                  onChange={onChangeQRCode("qr_code")}
                  value={searchFormValuesQR.qr_code}
                  placeholder="Enter QR Code"
                  onKeyPress={handleEnterPress}
                />
              </div>
              {QRCodeError ? (
                <div>
                  <p className="errorText">Please Enter QR Code</p>
                </div>
              ) : null}
              <div>
                <Button
                  type="primary"
                  style={{ maxWidth: "75%" }}
                  onClick={searchUserByQRCode}
                >
                  Search
                </Button>
              </div>

              {couponStatus && (
                <div className="couponInfo">
                  <li>
                    <label>Status : {couponsInfo.status}</label>
                  </li>
                  {couponsInfo.redeemed_on && (
                    <li>Redeemed Date : {couponsInfo.redeemed_on}</li>
                  )}
                  {couponsInfo.redeemed_by.firstname !== "" && (
                    <li>
                      <label>
                        <strong>Customer Details</strong>
                      </label>
                      <ul>
                        <li>
                          <label>Firstname : </label>
                          {couponsInfo.redeemed_by.firstname}
                        </li>
                        <li>
                          <label>Lastname : </label>
                          {couponsInfo.redeemed_by.lastname}
                        </li>
                        <li>
                          <label>Mobile Number : </label>
                          {couponsInfo.redeemed_by.mobile}
                        </li>
                        <li>
                          <label>Email : </label>
                          {couponsInfo.redeemed_by.email
                            ? couponsInfo.redeemed_by.email
                            : " unavailable"}
                        </li>
                      </ul>
                    </li>
                  )}
                </div>
              )}
            </div>
          </div>
          {spinner && <Spin tip="Loading..." />}
          <Modal
            title="Jotun Master Painter"
            onCancel={handleCancel}
            footer={null}
            visible={isModalVisible}
            onOk={handleOk}
          >
            <p>{apiError}</p>
          </Modal>
          {/* <Divider></Divider> */}

          {/* <div className="ReceiptStatusContainer">
            <p className="formTitle">Receipt Status</p>
            <div className="ReceiptStatus">
              <div className="card">
                <img src={receipts} alt="" />
                <p>Total Receipts</p>
                <strong>851</strong>
              </div>
              <div className="card">
                <img src={pending} alt="" />
                <p>Pending Receipts</p>
                <strong>851</strong>
              </div>
              <div className="card">
                <img src={approved} alt="" />
                <p>Approved Receipts</p>
                <strong>851</strong>
              </div>
              <div className="card">
                <img src={rejected} alt="" />
                <p>Rejected Receipts</p>
                <strong>851</strong>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default SearchAndStatus;
